import { theme } from 'lib/theme';
import { View } from 'react-native';
import { Txt } from 'components/Txt';

export const ProgressBar: React.FC<{
  barValue: number | 0;
  barTotal: number | 0;
  height?: number;
  barValueMsg: string | '';
  barEmptyMsg: string | '';
}> = ({
  barValue,
  barTotal,
  height = 8,
  barValueMsg = '',
  barEmptyMsg = '',
}) => {
  const empty = barValue !== 0;
  const pct =
    barTotal > 0 && empty ? Math.round((barValue / barTotal) * 100) : 0;

  return (
    <View style={{ width: '100%' }}>
      <View
        style={{
          height,
          marginTop: 3,
          borderRadius: 999,
          overflow: 'hidden',
          backgroundColor: theme.colors.black10,
        }}
      >
        <View
          style={{
            height: '100%',
            width: `${pct}%`,
            backgroundColor: empty ? theme.colors.blue : theme.colors.black80,
          }}
        />
      </View>

      <View
        style={{
          marginTop: 6,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Txt size="xxsmall" numberOfLines={1}>
          {empty ? `${barValue}/${barTotal} ${barValueMsg}` : `${barEmptyMsg}`}
        </Txt>
        <Txt size="xxsmall" numberOfLines={1}>
          {empty && barTotal > 0 ? `${pct}%` : `${barTotal} total`}
        </Txt>
      </View>
    </View>
  );
};
